import * as ATypes from '../../shared/actionTypes';

const defaultState = {
  action: null,
  payload_code: null,
  authority: null,
  country: null,
  needsDeeplinkRedirection: false,
};

export const deeplinkReducer = (state = defaultState, reduxAction) => {
  switch (reduxAction.type) {
    case ATypes.SET_DEEPLINK_DATA:
      return {
        ...defaultState,
        ...reduxAction.payload,
      };
    case ATypes.CLEAR_DEEPLINK_DATA:
    case 'persist/PURGE':
      return { ...defaultState };
    default:
      return state;
  }
};
